export default "__VITE_ASSET__CR$CVbTt__"